import * as React from 'react';
import { SerializedStyles } from '@emotion/core';
import RaterApprovalMenu from './RaterApprovalMenu';
import DashboardLayout from '../layout/DashboardLayout';


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
};


/**
 * RaterApprovalLayout: a component that renders the root layout of approver pages with the side menu containing
 * approver area links and the main content area.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RaterApprovalLayout: React.FC<Props> = props => (
  <DashboardLayout {...props} menu={<RaterApprovalMenu />}>
    {props.children}
  </DashboardLayout>
);

export default RaterApprovalLayout;
